import { MatchedEmployee } from '@/modules/employer/components/Lockbox/lockbox.types';

export const getMatchedEmployeeById = (employeeId?: string, accountId?: string, employees?: MatchedEmployee[]) => {
  if (!employeeId || !employees?.length) {
    return;
  }

  const matchedEmployee = employees?.find((employee) => {
    if (accountId && accountId !== employee?.accountId) {
      return false;
    } 

    return employee?.employeeId && employee?.employeeId === employeeId;
  });

  if (!matchedEmployee) {
    return;
  }

  return matchedEmployee;
};
